<template>
  <div
    class="
      link/focus
    "
    >
    <div
      class="
        $typography/size:medium
        layout/flex:row
        layout/grid:gap:cap
        layout/align:center
      "
      >
      <div
        class="
          @768/layout/border:3pt
          $color/black
          layout/align:center
          layout/border:2pt
          layout/flex
          layout/flex:shrink:disable
          layout/height:baseline:3
          layout/justify:center
          layout/relative
          layout/width:baseline:3
        "
        :class="{
          '$color/background:black $color/background:alpha:100% color/background': checked
        }"
        >
        <input
          :id="checkboxName"
          :data-gtm="gtm"
          type="checkbox"
          :name="checkboxName"
          aria-controls="pjax-tms-container"
          class="
            layout/absolute
            layout/bottom:0%
            layout/left:0%
            layout/right:0%
            layout/top:0%
            layout/width:100%
            layout/height:100%
            link/cursor
          "
          @click.prevent="toggle"
        >
        <Icon
          v-if="checked"
          icon-name="icon__check--16--stroke.svg"
          class-name="
            typography/icon
            link/disable
            $typography/size:medium
            $color/gray:eee
          "
          style="
            --typography--icon--size: calc(2 * var(--typography--size) * var(--rem-conversion));
            --typography--icon--stroke-width: calc(var(--typography--icon--stroke) * var(--typography--size) * var(--rem-conversion));
          "
        />
      </div>
      <label
        class="
          link/cursor
          typography
        "
        :for="checkboxName"
        v-html="label"
      />
    </div>
  </div>
</template>

<script>
  import i18n from '../../utils/i18n.js';
  import Icon from "../icons/icon.vue";

  export default {
    components: {Icon},
    props: {
      checkboxName: { type: String, required: true },
      checked: { type: Boolean, required: true },
      label: { type: String, required: true },
      gtm: { type: String, required: true },
    },
    data() {
      return {
        i18n: new i18n(),
      };
    },
    methods: {
      toggle() {
        this.$emit('clickedCheckbox', !this.checked);
      },
    }
  };
</script>
